import React from "react";
import ZETLogo from "../../../../../Images/ZETLogo.png";
import { VscVerified } from "react-icons/vsc";
import SafeImg from "../../../../../Images/safe.png";
import ChancesImg from "../../../../../Images/chances.png";
import QuickProcessImg from "../../../../../Images/quickProcess.png";
import BackgroundImg from "../../../../../Images/Background.png";

const OFFER_URL = "https://wee.bnking.in/c/ZjU1N2E3Y";

const FEATURES = [
  { src: SafeImg, alt: "Safe & Secure", label: "Safe &\nSecure" },
  { src: ChancesImg, alt: "Better Chances", label: "Better\nChances" },
  { src: QuickProcessImg, alt: "Quick Process", label: "Quick\nProcess" },
];

const LENDERS = [
  { name: "Lender Partner A", amount: "₹1,00,000", bestOffer: true },
  { name: "Lender Partner B", amount: "₹60,000", bestOffer: false },
  { name: "Lender Partner C", amount: "₹30,000", bestOffer: false },
];

const LenderCard = ({ name, amount, bestOffer }) => (
  <div className={`lr-card${bestOffer ? " lr-card-featured" : ""}`}>
    {bestOffer && <div className="lr-best-offer-badge">Best Offer</div>}
    <div className="lr-card-content">
      <p className="lr-card-name">{name}</p>
      <div className="lr-card-amount-block">
        <p className="lr-card-upto">upto</p>
        <p className="lr-card-amount">{amount}</p>
      </div>
      <div className="lr-verified">
        <VscVerified className="lr-verified-check" />
        <span className="lr-verified-text">Verified Lender</span>
      </div>
    </div>
    <button
      onClick={() => window.open(OFFER_URL, "_blank")}
      className="lr-check-offer-btn"
    >
      Check Offer <span className="lr-chevron">›</span>
    </button>
  </div>
);

const LoanRejectZet = () => {
  return (
    <div className="lr-wrapper">
      <div className="lr-icon-outer">
        <img src={BackgroundImg} alt="Loan Rejected" className="lr-bg-image" />
      </div>

      <h2 className="lr-title">Loan Application Rejected</h2>
      <p className="lr-subtitle">
        We couldn't approve your loan with our <br /> current model based on
        the recent evaluation.
      </p>

      <hr className="lr-divider" />

      <h3 className="lr-better-title-purple">Better Options,</h3>
      <h3 className="lr-better-title-black">More Possibilities!</h3>
      <p className="lr-better-desc">
        Trusted lenders on <strong>ZET</strong> can still help.
        <br />
        Check offers that fit your needs.
      </p>

      <div className="lr-features">
        {FEATURES.map(({ src, alt, label }) => (
          <div key={alt} className="lr-feature-item">
            <img src={src} alt={alt} className="lr-feature-img" />
            <span className="lr-feature-label">{label}</span>
          </div>
        ))}
      </div>

      <div className="lr-cards">
        {LENDERS.map((lender) => (
          <LenderCard key={lender.name} {...lender} />
        ))}
      </div>

      <button
        onClick={() => window.open(OFFER_URL, "_blank")}
        className="lr-explore-btn"
      >
        <img src={ZETLogo} alt="ZET" className="lr-explore-zet-logo" />
        Explore More Offers
      </button>
    </div>
  );
};

export default LoanRejectZet;
